import { Component } from 'react';
import PropTypes from 'prop-types';

export default class ErrorBoundary extends Component {
  static propTypes = {
    retcodeApiName: PropTypes.string,
  };

  static defaultProps = {
    retcodeApiName: 'defaultComponentRenderError',
  };

  state = {
    hasError: false,
  };

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error, info) {
    console.error(error);
    console.error('info:', info);
  }

  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
